module.exports = __webpack_public_path__ + "static/img/z08.a591d25f.png";